export const accents = {
  accent1: 'hsl(347 3% 9%)',
  accent2: '#333',
  accent3: '#444',
  accent4: '#666',
  accent5: '#888',
  accent6: '#999',
  accent7: '#dedede',
  accent8: '#f0f0f0',
}

export const purples = {
  purple8: 'rgba(94, 30, 226, .1)',
  purple6: 'rgb(80, 49, 207)',
  purple5: 'rgb(94, 30, 226)',
  purple4: 'rgb(161 115 255)',
}
